/* eslint-disable @typescript-eslint/no-unused-vars */
'use client'
export const safeLocalStorage: Storage = {
  getItem(key: string): string | null {
    try {
      return localStorage.getItem(key)
    } catch (e) {
      return null
    }
  },

  key(index: number): string | null {
    try {
      return localStorage.key(index)
    } catch (e) {
      return null
    }
  },

  get length(): number {
    try {
      return localStorage.length
    } catch (e) {
      return 0
    }
  },

  removeItem(key: string): void {
    try {
      localStorage.removeItem(key)
    } catch (e) {
      return
    }
  },

  setItem(key: string, value: string): void {
    try {
      localStorage.setItem(key, value)
    } catch (e) {
      return
    }
  },

  clear(): void {
    try {
      localStorage.clear()
    } catch (e) {
      return
    }
  },
}
